import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { UserStateService } from '../expense/receipt/detail/userState.service';
import { map } from 'rxjs';
import { DataService } from '../expense/receipt/data.service';

@Component({
  selector: 'app-notification-panel-component',
  standalone: true,
  imports: [
    NotificationPanelComponentComponent,
    CommonModule,
    MatCardModule,
    MatTabsModule,
    MatIconModule,
  ],
  templateUrl: './notification-panel-component.component.html',
  styleUrls: ['./notification-panel-component.component.css'],
})
export class NotificationPanelComponentComponent {
  @Input() isOpen: boolean = false;
  messages: any[] = [];
  userMessage: any[] = [];
  orgMessage: any[] = [];
  maxMessagesToShow: number = 5;
  userMessagesCount: number = 0;
  orgMessagesCount: number = 0;

  @ViewChild('contentUser') contentUser!: ElementRef;
  @ViewChild('contentOrg') contentOrg!: ElementRef;

  selectedTab: string = 'user';
  constructor(
    private userStateService: UserStateService,
    private ds: DataService
  ) {}
  roles: { role: string }[] = [];

  async ngOnInit(): Promise<void> {
   this.getAllNotification(this.getUserIdFromLocal());
    this.getUserRole();
    this.userStateService.rolesSubject
      .pipe(
        map((roles) => {
          return roles.map((x) => {
            return { role: x };
          });
        })
      )
      .subscribe((roles) => {
        if (roles) {
          this.roles = roles;
          // Log roles for debugging
          console.debug('Roles updated in notification:', roles);
        }
      });
  
    console.debug('Notification Panel is initialized. isOpen:', this.isOpen);
  }
  
  switchTab(event: MatTabChangeEvent): void {
    console.debug('debug', event.tab.textLabel.toLowerCase());
    this.selectedTab = event.tab.textLabel.toLowerCase();
    this.loadDataForTab(this.selectedTab)
  }
  getUserRole(): void {
    this.ds.getParticularUserRole(this.getUserIdFromLocal()).subscribe(
      (response: any) => {
        this.roles = response._items;
        console.debug("'''''", response._items);
      },
      (error) => {
        console.error('Error fetching Role:', error);
      }
    );
  }

  async loadDataForTab(tab: string): Promise<void> {
    console.debug(tab, 'tabbb');

    if (tab === 'user') {
        console.debug('hello');
        this.userMessage = this.messages.filter(x => x.request_send_to_org);
        console.debug(this.userMessage, "this.UserMessages");
    } else if (tab === 'org') {
        this.orgMessage = this.messages.filter(x => x.request_send_to_user);
        console.debug(this.orgMessage, "this.orgMessages");
    }
}

  async getAllNotification(userId: string): Promise<void> {
    console.debug(userId);
    this.ds.getNotificationsForUser(userId).subscribe((response: any) => {
      console.debug('notification:::', response._items);
      this.messages=response._items
      this.loadDataForTab(this.selectedTab);
    });
  }
  getUserIdFromLocal(): string {
    const storedResponse = localStorage.getItem('LoginResponse');
    if (storedResponse !== null) {
      const parsedResponse = JSON.parse(storedResponse);
      return parsedResponse._items[0].user_id;
    } else {
      console.error('Stored response is null');
      return '';
    }
  }
  isLoggedIn(): boolean {
    return !!localStorage.getItem('currentUser');
  }
  hasRole(targetRole: string): boolean {
    console.debug('rolesss:::', this.roles);
    return (
      this.isLoggedIn() && this.roles.some((role) => role.role === targetRole)
    );
  }
  close() {
    this.isOpen = !this.isOpen;
  }
}
